// cart auto-refresh
(() => {
  const originalFetch = window.fetch;
  
  window.fetch = function(...args) {
    const url = args[0];
    
    if (url && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))) {
      return originalFetch.apply(this, args).then((response) => {
        if (response.ok) {
          const waitForCartDrawer = () => {
            const cartDrawer = document.querySelector('cart-drawer');
            
            if (cartDrawer && customElements.get('cart-drawer')) {
              setTimeout(() => {
                document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
              }, 500);
            } else {
              setTimeout(waitForCartDrawer, 100);
            }
          };
          
          waitForCartDrawer();
        }
        return response;
      });
    }
    
    return originalFetch.apply(this, args);
  };

  document.addEventListener('click', (e) => {
    const removeButton = e.target.closest('cart-remove-button .cart-remove-button');
    
    if (removeButton) {
      const waitForCartDrawer = () => {
        const cartDrawer = document.querySelector('cart-drawer');
        
        if (cartDrawer && customElements.get('cart-drawer')) {
          setTimeout(() => {
            document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
          }, 500);
        } else {
          setTimeout(waitForCartDrawer, 100);
        }
      };
      
      waitForCartDrawer();
    }
  });
})();

// selling plan management
(() => {
  if (window.location.pathname.includes('/products/')) {
    setTimeout(() => {
      window.Abra.useSellingPlanPriceOnProductBlock = true;
      window.Abra.render();
    }, 100);
  }
})();